import React from 'react';
import './error-sec.css'
import pic21 from '../assets/pic21.png'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import { useNavigate } from 'react-router-dom';


const Errorsec = () => {
const navigate = useNavigate();

 const [error, seterror]= useState([]);
      useEffect(() => {
      const geterror = async()=>{
          const res = await supabase.from('error_page_mobile').select('*').order('id', { ascending: true });;;
    
      seterror(res.data);
      }
      geterror();
      }, []);


    return ( 
        <section className='sec-error'>
            <img className='decoration-img-error'  src={pic21} alt='decoration'></img>
            <section className='main-contantainer-information-error-page'>
                    <img  className='error-img' src={error?.[0]?.img} alt='error-img'></img>

                    <article className='text-information-error'>
                        <h1 className='error-header'>{error?.[0]?.header} </h1>
                        <p className='para-error'> {error?.[0]?.para} </p>
                        <Cta title={error?.[0]?.cta}  onClick={() => navigate('/home')} />
                    </article>
            </section>
        </section>
     );
}
 
export default Errorsec;